import { axios } from '@carvana/purchase-utils';

// TODO: get additional information from cvaccesstoken cookie
export const getCoreConfig = () =>
  axios
    .get('/reservation/getcarvanacoreconfig')
    .then(res => res.data)
    .catch(err => {
      throw err?.message || err;
    });

export const getPurchaseRoute = () =>
  axios
    .get('/purchase/route-from-bucket')
    .then(res => res.data)
    .catch(err => {
      throw err?.message || err;
    });

export const getUsersExperiments = userId =>
  axios
    .get(
      `${process.env.SPLITTEST_API_URL}/api/v2/identifier/profile?IdentifierType=CarvanaUserId&Identifier=${userId}`
    )
    .then(res => res.data)
    .catch(() => {});
